<template>
	<div v-if="event">
		<Loader :show="loading" type="inline" />

		<div class="card p-0 mb-4 bg-warning" v-if="!loading && !event.canEdit">
			<div class="card-body p-3">
				<div class="d-flex justify-content-between">
					<div v-if="event.status == 'ENDED'">
						<h5 class="text-white">El evento ya ha finalizado</h5>
					</div>
					<div v-if="event.status == 'CANCELLED'">
						<h5 class="text-white">Evento cancelado</h5>
					</div>
				</div>
			</div>
		</div>
		<div class="card p-0 mb-4" v-if="!loading && event.canEdit">
			<div class="card-body p-3">
				<div class="d-flex justify-content-between">
					<div>
						<h5>Publicación y visibilidad</h5>
						<p>¿Cuándo quieres que el evento esté disponible en las tiendas seleccionadas?</p>

						<p class="text-danger bolder" v-if="event.isProgrammed">
							Fecha y hora de publicación: {{ event.publicFrom | moment("dddd DD MMM YYYY, HH:mm") }}
						</p>
					</div>
					<div>
						<b-dropdown
							right
							variant="outline-secondary"
							ref="publishDropdown"
							:text="form.isProgrammed ? 'Programado' : 'Inmediatamente'"
							@show="dropdownOpened = true"
							@hide="
								(e) => {
									if (this.dropdownOpened) e.preventDefault()
								}
							"
						>
							<b-dropdown-form style="width: 350px;" class="py-2">
								<h5><small>¿Cuándo quieres que se publique este evento?</small></h5>

								<b-form-group class="mt-3 mb-2">
									<b-form-radio v-model="form.isProgrammed" name="publicNow" :value="false">
										<h6>Inmediatamente</h6>

										<p class="text-secondary">
											Muestra este evento en cuanto se publique en nuestra web
										</p>
									</b-form-radio>
									<b-form-radio v-model="form.isProgrammed" name="publicNow" :value="true">
										<h6>En el futuro</h6>
										<p>Elige una fecha para publicar el evento en la web</p>
									</b-form-radio>
								</b-form-group>

								<div v-show="form.isProgrammed">
									<FormulateInput
										type="date"
										label="Fecha y hora de publicación"
										v-model="form.publicFrom"
										:displayFormat="'DD-MM-YYYY HH:mm'"
										validation-name="Fecha y hora de publicación"
										:validation="`before:${$moment(event.startAt).format('YYYY-MM-DD HH:mm:01')}`"
										class="flex-grow-1 "
										:max="$moment(event.startAt).format('YYYY-MM-DD HH:mm:01')"
										:validation-messages="{
											before: `La fecha de fecha de publicación no puede ser posterior a la fecha de inicio del evento ${$moment(
												event.endAt
											).format('DD-MM-YYYY HH:mm')}`
										}"
									/>
								</div>

								<div class="d-flex justify-content-between">
									<div class="btn btn-secondary mt-3" @click="closeDropwdown">
										Cancelar
									</div>
									<div class="btn btn-primary mt-3" @click="update">
										Programar
									</div>
								</div>
							</b-dropdown-form>
						</b-dropdown>
					</div>
				</div>
			</div>
			<div class="card-body p-3 bg-grey">
				<div class="d-flex align-items-center justify-content-between">
					<div class="d-flex">
						<i class="icon icon-xl">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								class=" icon-tabler icon-tabler-eye-off"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								stroke-width="2"
								stroke="currentColor"
								fill="none"
								stroke-linecap="round"
								stroke-linejoin="round"
							>
								<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
								<line x1="3" y1="3" x2="21" y2="21"></line>
								<path d="M10.584 10.587a2 2 0 0 0 2.828 2.83"></path>
								<path
									d="M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"
								></path>
							</svg>
						</i>
						<div>
							<h4><small>Establecer como evento privado</small></h4>
							<p>
								Obtén un enlace de evento privado para compartir y que no se muestre este evento en la
								web de cobraticket.
							</p>
						</div>
					</div>

					<div>
						<toggle-button
							v-model="event.isPrivate"
							:color="{ checked: '#ffc107', unchecked: '#30c433' }"
							:width="80"
							:height="32"
							:labels="{ checked: 'Privado', unchecked: 'Público' }"
							@change="update"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="card" v-if="!loading">
			<div class="card-body p-3 ">
				<h5>Enlace de evento</h5>
				<p v-if="event.isPrivate">
					Este evento solo será visible para las personas con las que compartas el enlace privado.
				</p>
				<p v-else>Compartí el enlace al evento para promocionarlo y obtener mas ventas.</p>

				<ShareLink :link="event.publicLink" />
			</div>
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag"
import ShareLink from "@/components/ShareLink"
export default {
	name: "EventPublising",
	components: {
		ShareLink
	},
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			event: null,
			loading: true,

			isProgrammed: false,
			form: {
				isProgrammed: false,
				publicFrom: null
			},
			dropdownOpened: false,
			now: this.$moment().toDate()
		}
	},
	async beforeMount() {
		await this.load()
		this.loading = false
	},

	methods: {
		closeDropwdown() {
			this.dropdownOpened = false
			this.$refs.publishDropdown.hide()
		},

		update() {
			this.closeDropwdown()
			this.saving = true
			let data = {
				isPrivate: this.event.isPrivate,
				publicFrom: !this.form.publicNow ? this.form.publicFrom : this.now
			}
			return this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: EventInput!) {
							eventUpdate(id: $id, data: $data) {
								id
							}
						}
					`,
					variables: {
						id: this.eventId,
						data
					}
				})
				.then(({ data }) => {
					this.saving = false
					this.$toast.success("Cambios guardados correctamente")
					this.load()
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
		},

		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								startAt
								isPrivate
								publicFrom
								publicLink
								isProgrammed
								canEdit
								status
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.event = {
						id: data.event.id,
						isPrivate: data.event.isPrivate,
						startAt: data.event.startAt,
						publicFrom: data.event.publicFrom,
						publicLink: data.event.publicLink,
						isProgrammed: data.event.isProgrammed,
						canEdit: data.event.canEdit,
						status: data.event.status
					}

					this.form = {
						isProgrammed: data.event.isProgrammed,
						publicFrom: data.event.publicFrom
					}

					return data.event
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss"></style>
